import api from '@motionelements/core/src/api/base-api-v2';

const baseUrl = '/v2/artist/metadata-files';

export default {
  getLatestFile() {
    return api.get(`${baseUrl}/latest`);
  },
  getRows(id, params) {
    return api.get(`${baseUrl}/${id}/rows`, { params });
  },
  getHeaders(id) {
    return api.get(`${baseUrl}/${id}/headers`);
  },
  getFieldsOptions(id) {
    return api.get(`${baseUrl}/${id}/fields`);
  },
  getCategories(id) {
    return api.get(`${baseUrl}/${id}/categories`);
  },
  getCreators(id, type) {
    return api.get(`${baseUrl}/${id}/creators`, {
      params: {
        type,
      },
    });
  },
  getReleases(id, type) {
    return api.get(`${baseUrl}/${id}/releases`, {
      params: {
        type,
      },
    });
  },
  upload() {
    return api.request('post', `${baseUrl}/upload-url`);
  },
  createFile({ url, type }) {
    return api.request('post', baseUrl, {
      data: { url, type },
    });
  },
  updateFile(id, params) {
    return api.request('patch', `${baseUrl}/${id}`, {
      data: params,
    });
  },
  importFile(id, params) {
    return api.request('post', `${baseUrl}/${id}/import`, {
      data: params,
    });
  },
};
